import { AxiosResponse } from 'axios'

import axios from '../../axios'

export const agreementQualityCsv = async (
  year: number,
  month: number,
  agencyCode?: string
): Promise<AxiosResponse> => {
  const response = await axios
    .get(`/api/commissions/agreement-quality/csv/download`, {
      params: { agencyCode, year, month },
    })
    .catch((error) => {
      return error.response
    })

  return response
}
